const state = {
    latestNotification: null,
};
const getters = {
    latestNotification: state => {
        return state.latestNotification;
    },
};
const actions = {
    addNotification(context, notification) {
        context.commit('setLatestNotification', notification);
   },
};
const mutations = {
    setLatestNotification(state, notification) {

        let icon = null;

        switch(notification.status) {

            case 'loading':
                notification.status = 'info';
                icon = '/images/load.svg';
                break;

            case 'success':
                icon = '/images/success.svg';
                break;

            case 'info':
                icon = '/images/info.svg';
                break;

            case 'error':
                icon = '/images/error.svg';
                break;
        }

        if(! notification.icon) {
            notification.icon = icon;
        }

        notification.blockClass = 'flash';

        state.latestNotification = notification;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};